import React from "react";
import Dashboard from "./Dashboard/Dashboard";
import Proposals from "./Proposals/Proposals";
import Orders from "./Orders/Orders";
import UserProfile from "./UserProfile/UserProfile";
import UserSupport from "./UserSupport/UserSupport";
import { UserDashboard, UserDashboardContext } from "./UserDashboard";

export interface UserDashboardContentProps {
  step: string;
}

export type Contents = {
  [key: string]: JSX.Element;
};

export const UserDashboardContent = (
  props: UserDashboardContentProps
): JSX.Element => {
  const dashboardContext: UserDashboard =
    React.useContext(UserDashboardContext);

  const contents: Contents = {
    Dashboard: (
      <Dashboard
        userAccount={dashboardContext.state.userAccount}
        orders={dashboardContext.state.orders}
        handleNavigation={dashboardContext.handleNavigation}
      />
    ),
    Proposals: <Proposals orders={dashboardContext.state.orders} />,
    Shipments: <Orders orders={dashboardContext.state.orders} />,
    Profile: (
      <UserProfile
        userAccount={dashboardContext.state.userAccount}
        JWT={dashboardContext.state.JWT}
      />
    ),
    Support: <UserSupport messages={dashboardContext.state.messages} />,
  };

  return contents[props.step] ?? <></>;
};
